import React, { useState, useEffect } from 'react';
import { LoadingSpinner } from 'yankees-react-utils';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ObjectiveCategoriesFilter from './ObjectiveCategoriesFilter';
import ObjectiveCategory from './Category';
import { useOktaQuery, PlayerDevObjectives } from '../../data';
import usePlayerSelector from '../../utils/usePlayerSelector';

const ObjectivesTitle = styled.h2`
    font-weight: bold !important;
`;
const ObjectivesContainer = styled.div`
    padding: 0.75rem;
    font-size: 13px;
`;

const MyObjectivesHome = () => {
    const { t: translate } = useTranslation();
    const { PlayerID } = usePlayerSelector();
    const [playerDevObjectives, setPlayerDevObjectives] = useState([]);
    const [categories, setCategories] = useState([]);

    const { status } = useOktaQuery(
        ['playerDevObjectives', { playerId: PlayerID }],
        (t) => PlayerDevObjectives.get(t, { playerId: PlayerID }),
        { onSuccess: (result) => setPlayerDevObjectives(result) },
    );

    useEffect(() => {
        const uniqueCategories = [...new Map(playerDevObjectives?.map((o) => o.Category).map((c) => [c.CategoryID, c])).values()].sort((a, b) => a.SortOrder - b.SortOrder);
        setCategories([{
            name: translate('common.all'),
            isSelected: true,
            categoryId: null,
            isAll: true,
        }, ...uniqueCategories.map((c) => ({
            name: c.Name,
            isSelected: true,
            categoryId: c.CategoryID,
            isAll: false,
        }))]);
    }, [playerDevObjectives, translate]);

    if (status === 'loading') {
        return (
            <div className="d-flex justify-content-center py-5">
                <LoadingSpinner />
            </div>
        );
    }

    if (!playerDevObjectives.length) {
        return (
            <div>
                <ObjectivesTitle>{translate('sections.my-objectives.my-objectives')}</ObjectivesTitle>
                <div>{translate('sections.my-objectives.no-objectives')}</div>
            </div>
        );
    }

    return (
        <div>
            <ObjectivesTitle>{translate('sections.my-objectives.my-objectives')}</ObjectivesTitle>
            <ObjectivesContainer>
                <ObjectiveCategoriesFilter categories={categories} updateCategories={setCategories} />
                <div className="mt-4">
                    {categories
                        .filter((c) => c.isSelected && !c.isAll)
                        .map((c) => <ObjectiveCategory category={c} objectives={playerDevObjectives.filter((o) => o.Category.CategoryID === c.categoryId)} key={c.categoryId} />)}
                </div>
            </ObjectivesContainer>
        </div>
    );
};

export default MyObjectivesHome;
